<template>
  <svg aria-hidden="true" role="img" viewBox="0 0 32 32">
    <path
      fill="currentColor"
      d="M15.997 13.374l-7.081 7.081L7 18.54l8.997-8.998 9.003 9-1.916 1.916z"
    ></path>
  </svg>
</template>
